import ArchiveFiltersController from '../ArchiveFiltersController';
import type { ArchiveFilterModule } from '../types';

class PaginationFilter implements ArchiveFilterModule {
    private controller: ArchiveFiltersController | null = null;
    private container: HTMLElement | null = null;

    public mount(controller: ArchiveFiltersController): void {
        this.controller = controller;
        this.init();
    }

    private init(): void {
        this.container = document.querySelector('[data-container]');

        if (!this.container) {
            return;
        }

        this.bindEvents();
    }

    private bindEvents(): void {
        if (!this.container) {
            return;
        }

        this.container.addEventListener('click', (event) => {
            const target = event.target;

            if (!(target instanceof HTMLElement)) {
                return;
            }

            const link = target.closest<HTMLAnchorElement>('.page-numbers a');

            if (link && link.tagName === 'A' && link.href) {
                event.preventDefault();
                this.handlePaginationClick(link);
            }
        });
    }

    private handlePaginationClick(link: HTMLAnchorElement): void {
        const pageNumber = this.extractPageNumber(link.href);

        if (pageNumber) {
            this.loadPage(pageNumber);
        }
    }

    private extractPageNumber(url: string): number | null {
        try {
            const urlObject = new URL(url);
            const pathMatch = urlObject.pathname.match(/\/page\/(\d+)\/?/);

            if (pathMatch) {
                return parseInt(pathMatch[1], 10);
            }

            const paged = urlObject.searchParams.get('paged') || urlObject.searchParams.get('page');

            if (paged) {
                return parseInt(paged, 10);
            }

            return 1;
        } catch (error) {
            console.error('Failed to extract page number:', error);
            return null;
        }
    }

    private loadPage(pageNumber: number): void {
        this.controller?.setPage(pageNumber);
        this.scrollToTop();
    }

    private scrollToTop(): void {
        if (!this.container) {
            return;
        }

        const offset = 100;
        const elementPosition = this.container.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    }
}

export default PaginationFilter;